import { Model } from "@shared-features/models/model";
import { LanguageEnum } from "@shared/enums/language.enum";
import { Expose, Type } from "class-transformer";

export class TourGuide extends Model {
    @Expose() id: number;
    @Expose() releaseNoteItemId: number;
    @Expose() name: string; // moduleId
    @Expose() title: string; // release note section title
    @Expose() description: string; // release note section description
    @Expose() isVisited: boolean;

    @Type(() => TourGuideItem)
    @Expose() items: TourGuideItem[];

    @Expose() get steps(): TourGuideItem[] { // Frontend only
        return this.items;
    }
}

export class TourGuideItem extends Model {
    @Expose() id: number;
    @Expose() tourGuideId: number;
    @Expose() position: string;
    @Expose() hasNextAction: boolean;
    @Expose() originalTitle?: string; // Frontend only
    @Expose() isTextUpdated?: boolean = false; // Frontend only
    @Expose() itemIndex: number;

    @Type(() => TourGuideItemTranslation)
    @Expose() translations: TourGuideItemTranslation[];
}

export class TourGuideItemTranslation extends Model {
    @Expose() id: number;
    @Expose() title: string;
    @Expose() description: string;
    @Expose() languageIsoCode: LanguageEnum;
}